import { memo, useState } from 'react';
import {
  Button,
  Popover,
  PopoverBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
} from 'reactstrap';
import { DatePickerFilter } from './components/FilterContent';
import { find } from 'lodash';

const FILTER_MODAL = {
  isOpen: false,
  activeTab: 1,
};

type DateRange = {
  startDate: Date | null;
  endDate: Date | null;
};

export const DatePicker = memo(
  ({ filterCriteria }: { filterCriteria: any[] }) => {
    const [filterPopover, setFilterPopover] = useState(FILTER_MODAL);
    const [selectedDate, setSelectedDate] = useState<DateRange>({
      startDate: null,
      endDate: null,
    });

    const today = new Date();
    const { isOpen, activeTab } = filterPopover;

    const toggleFilterPopover = () => {
      setFilterPopover({ ...filterPopover, isOpen: !isOpen });
    };

    const toggleTabs = (status: number) => {
      setFilterPopover({ ...filterPopover, activeTab: status });
    };

    const activeCriteria = find(filterCriteria, o => o.id === activeTab);

    return (
      <>
        <Button id="date-button" onClick={toggleFilterPopover} className="filter-button-body" >
          <i className="bi bi-calendar me-2"></i>
          {selectedDate.startDate
            ? `${selectedDate.startDate.toLocaleDateString()} - ${selectedDate.endDate?.toLocaleDateString()}`
            : `${today.toLocaleDateString()} - ${today.toLocaleDateString()}`}
        </Button>

        {isOpen && (
          <Popover
            target="date-button"
            isOpen={isOpen}
            popperClassName="datepicker-popover"
          >
            <PopoverBody>
              <div className="datepicker-box">
                {/* LEFT */}
                <Nav tabs vertical>
                  {filterCriteria.map(row => (
                    <NavItem key={row.id}>
                      <NavLink
                        className={row.id === activeTab ? 'active' : ''}
                        onClick={() => toggleTabs(row.id)}
                      >
                        {row.tabHeading}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>

                {/* RIGHT */}
                <TabContent activeTab={activeTab}>
                  <DatePickerFilter
                    activeCriteria={activeCriteria}
                    onDateChange={setSelectedDate}
                  />
                </TabContent>
              </div>
            </PopoverBody>
          </Popover>
        )}
      </>
    );
  }
);
